import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";
import TextImagePanelWidget from "../TextImagePanelWidget/TextImagePanelWidgetClass";

Scrivito.provideEditingConfig("HeroSliderWidget", {
  title: "Hero Slider",
  attributes: localizeAttrList(
    ["dotsDescription", "panels"],
    "HeroSliderWidget"
  ),
  properties: ["panels", "dotsDescription", "background"],
  initialContent: {
    dotsDescription: "Foliennummer",
    panels: [new TextImagePanelWidget(), new TextImagePanelWidget()],
  },
  validations: [
    (obj) => {
      const panels = obj.get("panels");
      let isTextTooLong = false;
      for (let i = 0; i < panels.length; i += 1) {
        const description = panels[i].get("description");
        isTextTooLong = description.length >= 330;
        if (isTextTooLong) {
          break;
        }
      }
      if (isTextTooLong) {
        return "One of Text Image Panels contains too long content text";
      }
      return null;
    },
  ],
});
